import Dispatcher from '../core/Dispatcher';
import {Constants} from '../constants';
import BaseStore from './BaseStore';
import assign from 'object-assign';
import {fromJS, Map} from 'immutable';
import _ from 'lodash';

const PriceAlertsStore = assign({}, BaseStore, {
  initialize() {
    PriceAlertsStore.setState({
      priceAlerts:      Map(),
      entities:         Map(),  // Store all normalized entities
      newAlertsCount:   0,
      search:           Map(),
      loadingStatus:    Constants.LOADING,
      errCode:          null
    });
  },

  dispatchToken: Dispatcher.register(function (payload) {
    var action = payload.action;
    switch (action.actionType) {
      case Constants.ActionPriceAlerts.LOAD_PRICE_ALERTS_ERROR:
      case Constants.ActionPriceAlerts.LOAD_PRICE_ALERT_ERROR:
        PriceAlertsStore.setState({
          loadingStatus: Constants.ERROR,
          errCode:       action.err && action.err.status ? action.err.status : '500'
        });
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.LOAD_PRICE_ALERTS_SUCCESS:
        PriceAlertsStore.setState({
          priceAlerts:   fromJS(action.data.entities.priceAlerts ? action.data.entities.priceAlerts : {}),
          entities:      fromJS(action.data.entities || {}),  // Store all entities
          loadingStatus: Constants.LOADED
        });
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.LOAD_PRICE_ALERT_SUCCESS:
        var id = action.data.result.priceAlerts || action.data.result;
        var nextData = PriceAlertsStore.get('priceAlerts').set(String(id), fromJS(action.data.entities.priceAlerts[id]));
        // Merge new entities (history, users, etc.) into existing entities
        var currentEntities = PriceAlertsStore.get('entities');
        var newEntities = fromJS(action.data.entities || {});
        var mergedEntities = currentEntities.mergeDeep(newEntities);
        PriceAlertsStore.setState({
          priceAlerts:   nextData,
          entities:      mergedEntities,
          loadingStatus: Constants.LOADED
        });
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.SKIP_PRICE_ALERT_SUCCESS:
      case Constants.ActionPriceAlerts.RESOLVE_PRICE_ALERT_SUCCESS:
        var id = action.data.result.priceAlerts || action.data.result;
        var nextData = PriceAlertsStore.get('priceAlerts').set(String(id), fromJS(action.data.entities.priceAlerts[id]));
        // Merge new entities (history, users, etc.) into existing entities
        var currentEntities = PriceAlertsStore.get('entities');
        var newEntities = fromJS(action.data.entities || {});
        var mergedEntities = currentEntities.mergeDeep(newEntities);
        PriceAlertsStore.setState({
          priceAlerts: nextData,
          entities: mergedEntities
        });
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.BULK_SKIP_PRICE_ALERTS_SUCCESS:
        // Handle multiple alert updates
        var currentAlerts = PriceAlertsStore.get('priceAlerts');
        var currentEntities = PriceAlertsStore.get('entities');
        var newEntities = fromJS(action.data.entities || {});
        
        // Update each alert in the store
        var alertIds = action.data.result.priceAlerts || action.data.result || [];
        var updatedAlerts = currentAlerts;
        
        alertIds.forEach(function(alertId) {
          if (action.data.entities.priceAlerts && action.data.entities.priceAlerts[alertId]) {
            updatedAlerts = updatedAlerts.set(String(alertId), fromJS(action.data.entities.priceAlerts[alertId]));
          }
        });
        
        PriceAlertsStore.setState({
          priceAlerts: updatedAlerts,
          entities: currentEntities.mergeDeep(newEntities)
        });
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.DELETE_PRICE_ALERT_SUCCESS:
        var nextData = PriceAlertsStore.get('priceAlerts').delete(String(action.alertId));
        PriceAlertsStore.setState({priceAlerts: nextData});
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.LOAD_NEW_ALERTS_COUNT_SUCCESS:
        PriceAlertsStore.setState({newAlertsCount: action.count});
        PriceAlertsStore.emitChange();
        break;

      case Constants.ActionPriceAlerts.SEARCH_PRICE_ALERTS:
        // If value is empty, remove the field from search params
        if (!action.value || action.value.trim() === '') {
          var nextData = PriceAlertsStore.get('search').delete(action.field);
        } else {
          // Add or update the search field
          if (_.isUndefined(PriceAlertsStore.get('search').get(action.field))) {
            var nextData = PriceAlertsStore.get('search').set(action.field, action.value);
          } else {
            var nextData = PriceAlertsStore.get('search').update(action.field, v => v = action.value);
          }
        }
        PriceAlertsStore.setState({search: nextData});
        PriceAlertsStore.emitChange();
        break;
    }

    return true; // No errors. Needed by promise in Dispatcher.
  })
});

export default PriceAlertsStore;
